import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { HandleError, HttpErrorHandler } from '../../../util/http-error-handler.service';
import { Empresa } from '../../../models/empresa';
import { ParametroPagametoPonto } from '../../../models/parametroPagamentoPonto';
const API_URL = environment.apiUrl;


@Injectable({
  providedIn: 'root'
})
export class ParametroPagamentoPontoService {

  private handleError: HandleError;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError('RegiaoService');
  }

  search(param: any): Observable<any> {
    const params = new HttpParams()
      .set('pageNumber', `${param.offset}`)
      .set('pageSize', `${param.limit}`)
      .set('estado', `${param.estado == null ? '' : param.estado}`)
      .set('descricao', `${param.descricao}`)
      .set('ativo', `${param.ativo}`);

    return this.http.get<any>(API_URL + "pointpaymentparameter", { params })
      .pipe(
        catchError(this.handleError('search', []))
      );
  }

  create(record: ParametroPagametoPonto): Observable<ParametroPagametoPonto> {
    return this.http.post<ParametroPagametoPonto>(API_URL + "pointpaymentparameter/", record)
      .pipe(
        catchError(this.handleError('create', record))
      );
  }

  update(record: ParametroPagametoPonto): Observable<boolean> {
    return this.http.put<any>(API_URL + "pointpaymentparameter/", record)
      .pipe(
        catchError(this.handleError('update', record))
      );
  }

  detail(id: number): Observable<ParametroPagametoPonto> {
    return this.http.get<any>(API_URL + "pointpaymentparameter/" + id)
      .pipe(
        catchError(this.handleError('detail', []))
      );
  }
}
